// extracted by mini-css-extract-plugin
module.exports = {"root":"StaggerAnimateIn_root__X66qW","inView":"StaggerAnimateIn_inView__Y5Pwz"};